<template>
  <div class="mfa-recovery-page d-flex align-items-center justify-content-center">
    <div class="mfa-recovery-card text-center">
      <img src="images/logo-white-shadow.svg" alt="Logo" class="mfa-recovery-logo mb-3">
      <h1 class="mfa-recovery-title">
        Vérification nécessaire
      </h1>
      <p>
        La vérification par e-mail ne peut pas être terminée pour ce compte.
        Un administrateur doit mettre à jour ses informations.
      </p>
      <b-button variant="primary" block class="mt-4" @click="redirectToLogin">
        Retour à la connexion
      </b-button>
    </div>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import { clearPendingMfaChallenge } from '@/utils/mfaChallenge'

export default {
  name: 'MfaRecoveryRequired',
  components: {
    BButton,
  },
  created() {
    clearPendingMfaChallenge()
  },
  methods: {
    redirectToLogin() {
      clearPendingMfaChallenge()
      this.$router.replace({ name: 'login' })
    },
  },
}
</script>

<style scoped>
.mfa-recovery-page {
  min-height: 100vh;
  padding: 1rem;
  color: white;
  background: #202329 url('/images/refuge.jpg') center / cover;
  position: relative;
}

.mfa-recovery-page::before {
  content: '';
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.62);
}

.mfa-recovery-card {
  width: min(100%, 430px);
  padding: 2rem 3rem;
  border-radius: 10px;
  background: rgba(46, 46, 46, 0.9);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
  position: relative;
}

.mfa-recovery-logo {
  max-width: 180px;
}

.mfa-recovery-title {
  font-size: 1.5rem;
  font-weight: bold;
}

@media (max-width: 480px) {
  .mfa-recovery-card {
    padding: 1.5rem;
  }
}
</style>
